import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { trainings } from "../../constants/apiUrl";
import { ITrainingBlocks } from "../../models/master/training";

export default new (class TrainingBlockService {
  public getTrainingBlock = async (id: number): Promise<IApiResponse<ITrainingBlocks>> => {
    try {
      let endPoint = urlBinder(trainings.GET_TRAINING_BLOCK, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<ITrainingBlocks>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<ITrainingBlocks>;
      } else {
        throw error;
      }
    }
  };
 
  public getTrainingBlocks = async (
    pageBlockId?: number,
    noOfItems?: number,
    configUserType?: number
  ): Promise<IApiResponse<Array<ITrainingBlocks>>> => {
    try {
      let endPoint = urlBinder(trainings.GET_ALL_TRAINING_BLOCKS, [pageBlockId,noOfItems,configUserType]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<ITrainingBlocks>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<ITrainingBlocks>>;
      } else {
        throw error;
      }
    }
  };

  public createTrainingBlock = async (
    data: any
  ): Promise<IApiResponse<boolean | any>> => {
    try {
      let endPoint = trainings.CREATE_TRAINING_BLOCK;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean | any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean | any>;
      } else {
        throw error;
      }
    }
  };

  public updateTrainingBlock = async (
    data: any,
    id: number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(trainings.UPDATE_TRAINING_BLOCK, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateTrainingBlockPriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = trainings.UPDATE_TRAINING_BLOCK_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteTrainingBlock = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(trainings.DELETE_TRAINING_BLOCK, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
